export default __webpack_public_path__ + "static/media/401-error-unauthorized-amico.d79036ea.svg";